/**
 * School options for the SchoolName listing field.
 *
 * V1: Exported from the SchoolName "Select one" listing field (config assets response).
 * Add any new schools beyond the original 100 below; keep existing option values unchanged.
 * Exported list is sorted alphabetically by label so schools display in order everywhere.
 *
 * Shape: [{ option: string, label: string }, ...]
 */
const schoolOptionsRaw = [
  { label: 'Blackfriars Priory School', option: 'Blackfriars' },
  { label: 'East Adelaide School', option: 'EastAdelaide' },
  { label: 'Pembroke School', option: 'pembroke' },
  { label: 'Pulteney Grammar School', option: 'PulteneyGrammarSchool' },
  { label: "St Andrew's School", option: 'StAndrewsSchool' },
  { label: "St Monica's Parish School", option: 'StMonicas' },
  { label: "St Peter's College", option: 'StPetersCollege' },
  { label: "St Peter's Girls' School", option: 'st-peters-girls-school' },
  { label: 'Walkerville Primary School', option: 'WalkervillePrimary' },
  { label: 'Walford Anglican School for Girls', option: 'walford' },
  { label: 'Wilderness School', option: 'WildernessSchool' },
  { label: 'Annesley Junior School', option: 'Annesley' },
  { label: 'Bethany Christian School', option: 'Bethany' },
  { label: 'Blakes Crossing Christian College', option: 'BlakesCrossing' },
  { label: 'Cabra Dominican College', option: 'Cabra' },
  { label: 'Cardijn College', option: 'Cardijn' },
  { label: 'Cedar College', option: 'CedarCollege' },
  { label: 'Christian Brothers College', option: 'ChristianBrothers' },
  { label: 'Concordia College ', option: 'Concordia' },
  { label: 'Cornerstone College', option: 'Cornerstone' },
  { label: 'Emmaus Catholic School', option: 'EmmausCatholicSchool' },
  { label: 'Emmaus Christian College', option: 'EmmausChristianCollege' },
  { label: 'Encounter Lutheran College', option: 'EncounterLutheranCollege' },
  { label: 'Endeavour College', option: 'EndeavourCollege' },
  { label: 'Faith Lutheran College', option: 'FaithLutheranCollege' },
  { label: 'Garden College', option: 'GardenCollege' },
  { label: 'Gleeson College', option: 'GleesonCollege' },
  { label: 'Golden Grove Lutheran Primary School', option: 'GoldenGroveLutheranPrimary' },
  { label: 'Good Shepherd Lutheran School', option: 'GoodShepherdLutheran' },
  { label: 'Harvest Christian College', option: 'HarvestChristianCollege' },
  { label: 'Heritage College', option: 'HeritageCollege' },
  { label: 'Hope Christian College', option: 'HopeChristian' },
  { label: 'Horizon Christian School', option: 'HorizonChristian' },
  { label: 'Immaculate Heart of Mary School', option: 'ImmaculateHeartofMary' },
  { label: 'Immanuel College', option: 'ImmanuelCollege' },
  { label: 'Immanuel School Gawler', option: 'ImmanuelSchoolGawler' },
  { label: 'Indie School Port Adelaide Campus', option: 'IndieSchoolPortAdelaide' },
  { label: 'Investigator College', option: 'InvestigatorCollege' },
  { label: 'IQRA College', option: 'IQRACollege' },
  { label: 'Kildare College', option: 'KildareCollege' },
  { label: "King's Baptist Grammar School", option: 'KingsBaptistGrammar' },
  { label: 'Lobethal Lutheran School', option: 'LobethalLutheran' },
  { label: 'Loreto College', option: 'LoretoCollege' },
  { label: 'Loxton Lutheran School', option: 'LoxtonLutheran' },
  { label: 'Maitland Lutheran School', option: 'MaitlandLutheran' },
  { label: 'Mary MacKillop College', option: 'MaryMacKillopCollege' },
  { label: 'Mary MacKillop Memorial School', option: 'MaryMacKillopMemorialSchool' },
  { label: 'McAuley Community School', option: 'McAuleyCommunity' },
  { label: 'Mercedes College', option: 'MercedesCollege' },
  { label: 'Mid North Christian College', option: 'MidNorthChristianCollege' },
  { label: 'Mount Barker Waldorf School', option: 'MountBarkerWaldorf' },
  { label: 'Mount Carmel College', option: 'MountCarmelCollege' },
  { label: 'Mount Torrens Christian School', option: 'MountTorrensChristian' },
  { label: 'Navigator College', option: 'NavigatorCollege' },
  { label: 'Nazareth Catholic College', option: 'NazarethCatholicCollege' },
  { label: 'OneSchool Global SA - Aberfoyle Campus', option: 'OneSchoolGlobalSA' },
  { label: 'Our Lady of Grace School', option: 'OurLadyofGraceSchool' },
  { label: 'Our Lady of Hope School', option: 'OurLadyofHope' },
  { label: 'Our Lady of the River School', option: 'OurLadyoftheRiver' },
  { label: 'Adelaide International School', option: 'AdelaideInternationalSchool' },
  { label: 'All Saints Catholic Primary School', option: 'AllSaintsCatholicPrimary' },
  { label: 'Australian Islamic College Adelaide', option: 'AustralianIslamicCollegeAdelaide' },
  { label: 'Calvary Lutheran Primary School', option: 'CalvaryLutheranPrimarySchool' },
  { label: 'Caritas College', option: 'CaritasCollege' },
  { label: 'Catherine McAuley School', option: 'CatherineMcAuleySchool' },
  { label: 'Christ the King School', option: 'ChristtheKingSchool' },
  { label: 'Crossways Lutheran School Ceduna', option: 'CrosswaysLutheranSchoolCeduna' },
  { label: 'Dara School', option: 'DaraSchool' },
  { label: 'Dominican School', option: 'DominicanSchool' },
  { label: 'Saint Aloysius College', option: 'SaintAloysiusCollege' },
  { label: 'Holy Family Catholic School', option: 'HolyFamilyCatholicSchool' },
  { label: 'Our Lady of the Sacred Heart College', option: 'OurLadyofTheSacredHeartCollege' },
  { label: 'Our Lady of the Visitation School', option: 'OurLadyoftheVisitation' },
  { label: 'Our Lady Queen of Peace School', option: 'OurLadyQueenofPeace' },
  { label: 'Our Saviour Lutheran School', option: 'OurSaviourLutheran' },
  { label: 'Pedare Christian College', option: 'PedareChristianCollege' },
  { label: 'Pilgrim School', option: 'PilgrimSchool' },
  { label: 'Playford College', option: 'PlayfordCollege' },
  { label: 'Pinnacle College ', option: 'PinnacleCollege' },
  { label: 'Portside Christian College', option: 'PortsideChristianCollege' },
  { label: 'Prescott College', option: 'PrescottCollege' },
  { label: 'Prince Alfred College', option: 'PrinceAlfredCollege' },
  { label: 'Redeemer Lutheran School', option: 'RedeemerLutheran' },
  { label: 'Rivergum Christian College', option: 'RivergumChristianCollege' },
  { label: 'Rosary School', option: 'RosarySchool' },
  { label: 'Rostrevor College', option: 'RostrevorCollege' },
  { label: 'Sacred Heart College', option: 'SacredHeartCollege' },
  { label: "Saint David's Parish School", option: 'SaintDavidsParish' },
  { label: "Saint Ignatius' College", option: 'SaintIgnatiusCollege' },
  { label: 'Saint Spyridon College', option: 'SaintSpyridonCollege' },
  { label: 'Samaritan College', option: 'SamaritanCollege' },
  { label: 'School of the Nativity', option: 'SchooloftheNativity' },
  { label: 'Scotch College Adelaide', option: 'ScotchCollegeAdelaide' },
  { label: 'Seaview Christian College', option: 'SeaviewChristianCollege' },
  { label: 'Seymour College', option: 'SeymourCollege' },
  { label: 'Southern Montessori School', option: 'SouthernMontessoriSchool' },
  { label: 'Southern Vales Christian College', option: 'SouthernValesChristianCollege' },
  { label: "St Albert's Catholic School", option: 'StAlbertsCatholicSchool' },
  { label: 'St Aloysius College', option: 'StAloysiusCollege' },
  { label: "St Anthony's Catholic Primary School", option: 'StAnthonysCatholicPrimarySchool' },
  { label: "Woodcroft College", option: 'WoodcroftCollege' },
];

export const schoolOptions = [...schoolOptionsRaw].sort((a, b) =>
  (a.label || '').localeCompare(b.label || '', undefined, { sensitivity: 'base' })
);
